import { Component, Input, OnInit } from '@angular/core';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { SalesPackageAssignmentWSTO } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-packages-useradmin',
    templateUrl: './packages-useradmin.component.html',
    styleUrls: ['./packages-useradmin.component.scss']
})
export class PackagesUseradminComponent implements OnInit {
    @Input() public userPackages: SalesPackageAssignmentWSTO[] = [];

    private localizationDic: Map<string, string>;

    constructor(
        private uaService: UserAdminService,
        private localizationService: CVLocalizationService
    ) {
        this.constructorAsync();
    }

    ngOnInit(): void {
    }

    async constructorAsync() {
        this.localizationDic = await this.localizationService.GetSection("Users");
    }

}
